/**
 * @generated SignedSource<<18b3673fcfe456c51493594d5a44ca19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutProgressReview_deliveryOptions$data = ReadonlyArray<{
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryReview_shipmentQuote">;
  readonly " $fragmentType": "CheckoutProgressReview_deliveryOptions";
}>;
export type CheckoutProgressReview_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutProgressReview_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutProgressReview_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutProgressReview_deliveryOptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryReview_shipmentQuote"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "693b161917c72ef5057a5df0e710643e";

export default node;
